export const windowGlobal = () => typeof window !== 'undefined' && window
